// src/stores/trainingLaunchFallbackStore.ts
//
// When a monitored training launch cannot open the provider tab — the browser
// popup-blocked window.open (common on Safari), or consent/session setup failed
// after the user clicked "Agree & continue" — we must NOT leave the user stuck.
// This tiny store surfaces the target URL so a global dialog can offer a plain
// "Open training directly" anchor (a fresh user gesture Safari honors).
//
// Opening the training via this fallback does NOT imply completion — completion
// stays user-selected in the return prompt.
import { create } from 'zustand';

export type TrainingLaunchFallbackReason = 'popup_blocked' | 'launch_failed';

interface TrainingLaunchFallbackState {
  url: string | null;
  reason: TrainingLaunchFallbackReason | null;
  show: (url: string, reason?: TrainingLaunchFallbackReason) => void;
  clear: () => void;
}

export const useTrainingLaunchFallbackStore = create<TrainingLaunchFallbackState>((set) => ({
  url: null,
  reason: null,
  show: (url, reason = 'popup_blocked') => {
    if (url) set({ url, reason });
  },
  clear: () => set({ url: null, reason: null }),
}));
